import { render } from "./MarketInquiryReceipt.vue?vue&type=template&id=3d13a80e&scoped=true&ts=true"
import script from "./MarketInquiryReceipt.vue?vue&type=script&lang=ts"
export * from "./MarketInquiryReceipt.vue?vue&type=script&lang=ts"

import "./MarketInquiryReceipt.vue?vue&type=style&index=0&id=3d13a80e&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\jonatan\\Documents\\Repos\\milva-online\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d13a80e"]])

export default __exports__